export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Regular.woff?6fdf0ac577be0ba82a4c9a89b8eef91b";